import { useCallback, useEffect, useState } from "react";
import { objectToSnake } from "ts-case-convert";
import { api } from "services/api.service";
import { LocationInformationOptions } from "types/locationInformation";

function normalizeOptionKeys(options: LocationInformationOptions): LocationInformationOptions {
  return Object.getOwnPropertyNames(options).reduce((normalized, key) => {
    normalized[key as keyof LocationInformationOptions] = objectToSnake(
      options[key as keyof LocationInformationOptions],
    ) as Record<string, string>;
    return normalized;
  }, {} as LocationInformationOptions);
}

export default function useLocationInformationOptions() {
  const [selectOptions, setSelectOptions] = useState<LocationInformationOptions>();
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  const refetch = useCallback(() => {
    setIsLoading(true);
    setIsError(false);

    return api
      .get<LocationInformationOptions>("/location_informations/options")
      .then(({ data }) => {
        setSelectOptions(normalizeOptionKeys(data));
      })
      .catch(() => {
        setIsError(true);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return {
    selectOptions,
    isLoading,
    isError,
    refetch,
  };
}
